export default __webpack_public_path__ + "static/media/p-onprogress.00c299af.svg";